// CHINESE
export const locale = {
	lang: '简体中文',
	img: 'chinese.jpg',
	data: {
		MENU: {
			DASHBOARD: '首页',
			USER_MANAGER: '用户管理',
			DEVICE_MANAGER: '设备管理',
			DATA_MANAGER: '数据管理',
			REALTIME_DASHBOARD: '实时数据看板',
			DEV_CENTER: '开发管理',
			FIRMWARE_MANAGER: '固件管理',
			DATA_DISTRIBUTION: '数据分发',
			EDGE_COMPUTING: '边缘计算',
			PRODEVICE_MANAGER: '产品开发',
			APP_VERSION: 'APP管理',
			FEEDBACK: '用户反馈',
			MESSAGE: '消息推送',
			SETTINGS: '系统设置',
			DOCUMENT: '开发文档',
			REVIEW_DEVELOPERS: '实名审核',
			REVIEW_DEVICES: '产品审核',
			BASE_SETTINGS: '基础设置',
			ADMIN: '管理员',
			CONFIG_EDITOR: '配置编辑',
			KEY_MANAGER: '密钥管理',
			ORDER_MANAGER: '订单管理',
			PLATFORM_MANAGER: 'IOT平台管理',
			COAP_MANAGER: 'CoAP服务管理',
			VENDOR_MANAGER: '厂商管理',
			WX_PUSH: '微信推送管理',
			SECURITY_MANAGER: '安全监控'
		},
		WX_PUSH: {
			LIST: '推送记录',
			INFO: '推送详情',
			TITLE: '微信推送管理',
			STATS: '推送统计',
			TOTAL: '推送总数',
			SUCCESS: '成功',
			FAILED: '失败',
			SUCCESS_RATE: '成功率',
			PUSH_TYPE: '推送类型',
			DEVICE_NAME: '设备名称',
			STATUS: '状态',
			ERROR_MSG: '错误信息',
			CREATE_TIME: '创建时间',
			FILTER_UUID: '按用户UUID筛选',
			FILTER_TYPE: '按类型筛选',
			FILTER_STATUS: '按状态筛选',
			TYPE_TEMPLATE: '模板消息',
			TYPE_CUSTOMER: '客服消息',
			TYPE_ALERT: '设备告警',
			TYPE_AUTOMATION: '自动化通知',
			TEST_PUSH: '测试推送',
			REFRESH: '刷新'
		},
		VENDOR: {
			LIST: '厂商列表',
			INFO: '厂商详情',
			TOTAL: '总厂商数',
			ACTIVE: '活跃厂商',
			MINIPROGRAM_COUNT: '小程序配置数',
			CHANNEL_USERS: '渠道用户总数'
		},
		USER_MENU: {
			PROFILE: '账户信息',
			LOGOUT: '退出'
		},
		HOME: {
			DEVICE: '设备',
			DATA: '数据',
			SERVICE: '服务',
			OTHER: '其他',
			ACCOUNT: '关联账户'
		},
		USER: {
			LIST: '用户列表',
			INFO: '用户信息',
			GROUP0: '普通用户',
			GROUP1: '开发者',
			GROUP2: '教育版',
			PHONE: '手机号',
			DIYDEVICE_NUM: '独立设备',
			PRODEVICE_NUM: '专属设备',
			ACCOUNT: '关联账户',
			EXPIRE: '失效日期'
		},
		DEVICE: {
			LIST: '设备列表',
			INFO: '设备信息',
			STATE: '状态',
			ONLINE: '在线',
			OFFLINE: '离线',
			FIRMWARE_VERSION: '固件版本',
			ADDRESS: '地址',
			DEVICETYPE: '设备类型',
			MODE: '模式',
			DATA: '数据存储',
			ACCOUNT: '关联账户',
			BROKER: 'Broker',
		},
		DATA: {
			LIST: '数据列表',
			INFO: '数据详情',
			LINE: '折线图',
			BAR: '柱状图',
			NODATA: '没有可显示的数据',
		},
		PRODEVICE: {
			LIST: '产品列表',
			INFO: '产品信息',
			VENDER: '提供者',
			ICON: '图标',
			COMPONENT: 'UI组件',
			MODE: '连接模式',
			CONFIGURATOR: '配置方式',
			SPEECH: '语音配置',
			TIMER: '定时配置',
			DESCRIPTION: '简介信息',
			GUIDE: '向导信息',
			PUBLISH_STATE: '发布状态',
			PUBLISHED: '已发布',
			UNPUBLISHED: '未发布',
			PENDING: '待审核',
			REJECT: '拒绝',
			ACTIONS: '动作指令',
			TRIGGERS: '触发条件'
		},
		FIRMWARE: {
			LIST: '固件列表',
			INFO: '固件信息',
			VERSION: '版本',
			SIGN: '签名',
			SIZE: '大小',
			DATE: '上传时间',
			DESCRIPTION: '版本描述',
			TOTAL_NUM: '设备总数',
			CURRENT_NUM: '当前版本设备数'
		},
		APP: {
			LIST: '版本列表',
			INFO: '版本信息',
		},
		FEEDBACK: {
			LIST: '反馈列表',
			INFO: '反馈详情',
			TYPE: '反馈类型',
			CONTENT: '反馈内容'
		},
		MESSAGE: {
			LIST: '消息记录',
			INFO: '消息详情',
			TYPE: '消息类型',
			URL: '附带链接',
			ADMIN: '管理员发送',
			DEVICETYPE: '设备类型',
			CONTENT: '消息内容',
			SENDER: '发送者'
		},
		REVIEW_DEVELOPER: {
			LIST: '审核列表',
			INFO: '审核详情',
			USERNAME: '用户名',
			PHONE: '手机',
			VENDER: '认证名',
			IDCARD: '身份证',
			LICENSE: '营业执照',
			CREAT_DATE: '申请时间',
			STATE: '审核状态',
			REMARKS: '备注',
			REJECT: '拒绝',
			PENDING: '待审核',
			PASS: '通过'

		},
		REVIEW_DEVICES: {
			LIST: '审核列表',
			INFO: '审核详情'
		},
		ACTION: {
			TEXT: '可用操作',
			GOTO_DEVICE: '查看设备',
			CHANGE_PASSWORD: '修改密码',
			CHANGE_GROUP: '修改权限',
			DELETE_USER: '删除用户',
			GOTO_USER: '查看用户',
			GOTO_DATA: '查看数据',
			SHOW_LOG: '查看日志',
			SHOW_OBJECT: '设备影子',
			DELETE_DEVICE: '删除设备',
			UNBIND_DEVICE: '解绑设备',
			GET_API: '获取接口',
			DELETE_DATA: '删除数据',
			DOWNLOAD_FIRMWARE: '下载固件',
			TEST_FIRMWARE: '测试固件',
			PUBLISH_FIRMWARE: '发布固件',
			DELETE_FIRMWARE: '删除固件',
			RESOLVE_FEEDBACK: '解决',
			DELETE_FEEDBACK: '删除',
			DELETE_MESSAGE: '删除记录',
			PUBLISH_PRODEVICE: '发布产品',
			SHOW_KEY: '获取密钥',
			DELETE_PRODEVICE: '删除产品',
			REVIEW_PASS: '通过',
			REVIEW_REJECT: '拒绝',
			REVIEW_VENDER: '认证用户',
			CHANGE_STATE: '更改状态',
			DELETE_KEY: '删除密钥'
		},
		TIME: {
			H1: '1小时',
			H24: '24小时',
			D7: '7天',
			D30: '30天',
			Y1: '1年'
		},
		OTHER: {
			AVG: '平均值',
			MAX: '最大值',
			MIN: '最小值'
		},
		USERKEYS: {
			LIST: '用户密钥列表',
			INFO: '用户密钥详情',
			ACCESSKEY: 'AccessKey',
			SECRETKEY: 'SecretKey',
			STATUS: '状态',
			CREATEDAT: '创建时间'
		},
		ORDER: {
			LIST: '订单列表',
			INFO: '订单信息',
			ID: '订单号',
			STATE: '订单状态',
			PAID: '支付成功',
			PENDING: '待支付',
			CLOSED: '已关闭',
			PAY: '支付'
		}
	}
};